import PropTypes from "prop-types"
import { Avatar, ListItemAvatar, ListItemButton, ListItemText } from "@mui/material"
import { useDispatch } from "react-redux"

export default function LegacySearchResult({ id, type, label, secondary, Icon, action, clear }) {
  const dispatch = useDispatch()

  return <ListItemButton
    onClick={() => {
      clear()
      dispatch(action(id))
    }}
  >
    <ListItemAvatar>
      <Avatar className={`item-type-${type}`}>
        <Icon />
      </Avatar>
    </ListItemAvatar>
    <ListItemText primary={label} secondary={secondary} />
  </ListItemButton>
}

LegacySearchResult.propTypes = {
  id: PropTypes.string.isRequired,
  type: PropTypes.oneOf(["security", "swap", "factor"]).isRequired,
  label: PropTypes.string.isRequired,
  secondary: PropTypes.string.isRequired,
  Icon: PropTypes.object.isRequired,
  action: PropTypes.func.isRequired,
  clear: PropTypes.func.isRequired,
}
